// eslint-disable-next-line no-unused-vars
import { IModel } from '@src/js/separate-logic/interface/IModel';

import PluginManager from '@src/slide/domain/ui-model/plugin/pluginManager';
import CommonTips from '@src/framework/frame/components/common-tips';
import appConfigInstance, { setDefaultConfig } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { StatusBarConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

const getBoolean = (key, value) => setDefaultConfig(appConfigInstance.getConfig(key), value);

PluginManager.getInstance().initWithStore((AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
    .viewableServiceLayer.selectionService);
CommonTips.getInstance(); // 通用tips

export default class ContainerModel implements IModel {
    public showStatusBar: boolean;
    public initModel() {
        this.showStatusBar = getBoolean(StatusBarConfig.statusBar, true);
    }
}
